/**
 * TRACI-472 follow-up: the chat box's message length limit.
 *
 * Mirrors PROMPT_MAX_CHARS in backend/src/models/request_models.py (8_000 characters,
 * counted in code points like Python's len). Keep the two in step.
 */
export const CHAT_MESSAGE_MAX_CHARS = 8000;

/** Shown when a message is over the limit (before sending, or after a 413/422). */
export const MESSAGE_TOO_LONG_COPY =
  "That message is too long. Please shorten it to under 8,000 characters.";

/** Length in code points (what the backend counts), not UTF-16 units. */
export function messageLength(text: string): number {
  // Fewer than the cap in UTF-16 units can never be more in code points.
  return text.length <= CHAT_MESSAGE_MAX_CHARS ? text.length : Array.from(text).length;
}

export function isMessageTooLong(text: string): boolean {
  return messageLength(text) > CHAT_MESSAGE_MAX_CHARS;
}
